import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

export const Block = styled(Vertical)`
  padding: var(--double-unit);
  flex-shrink: 0;
  overflow-x: hidden;
  border-left: 1px solid var(--c-nd-150-opaque);
  @media ${laptopAndAbove} {
    padding: var(--triple-unit);
  }
  &:not(:last-child) {
    border-bottom: 1px solid var(--c-nd-150-opaque);
  }
  .PLAYER_PAGE & {
    border: none;
    padding-bottom: 0;
    padding-top: var(--half-unit);
    @media ${tabletAndAbove} {
      padding-inline: var(--double-unit);
    }
  }
`;

export const PlayerDrawerTokenSkeleton = styled(Skeleton)`
  width: 100%;
  height: calc(18.5 * var(--unit));
  border-radius: var(--unit);
`;

export const Root = styled(Vertical)`
  background-color: var(--c-black);
  flex-grow: 1;
  width: 100%;

  &.PLAYER_PAGE {
    border-left: 1px solid var(--c-nd-150);
    --manager-sales-header-padding: var(--unit) var(--double-unit) var(--unit);
    --manager-sales-header-top: calc(6 * var(--unit));
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;

  &.withBorder {
    padding: var(--double-unit);
    border: 1px solid var(--c-nd-150);
    border-radius: var(--unit);
  }
`;
export const Title = styled(LabelL).attrs({ bold: true })`
  display: flex;
  align-items: baseline;
  gap: var(--unit);
`;
